
export const TOAST_GROUPS = {
    EMAIL_VERIFICATION: 'email_verification',
}

export const EMAIL_VERIFICATION_TOAST_GROUP = TOAST_GROUPS.EMAIL_VERIFICATION